import { CHECKOUT_ROUTES } from '@app/constants/routes';
import { useRouteMatch } from 'react-router-dom';

const useCheckoutRoutes = () => {
  return useRouteMatch(CHECKOUT_ROUTES);
};

export default useCheckoutRoutes;
